
import { module as BaseModule } from 'modujs';
import { RevealFadeY } from '../fx/Common'
import gsap from 'gsap';

export default class extends BaseModule  {
  constructor(m) {
    super(m);
  }

  init()
  {
    this.DOM = {}
    this.DOM.view = this.el

    //!
    gsap.delayedCall(.5,()=>{
      this.fx()
    })

  }

  fx()
  {
    RevealFadeY(this.DOM.view)

  }


}
